export default {
  name: 'FooterBar',
  data () {
    return {
      fms: ''
    }
  },
  watch: {
    fms: async function () {
      if (this.fms !== '') window.open(this.fms)
      this.fms = ''
    }
  }
}
